import { EventEmitter } from 'fbemitter';

export const emitter = new EventEmitter();

export const notify = new Proxy(
  {},
  {
    get: (target, type) => {
      return (details, cb) => {
        details.type = type;
        emitter.emit('snackbar-show', details, cb);
      };
    },
  }
);



// WEBPACK FOOTER //
// ./src/notif.js